import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { useTranslation, Trans } from "react-i18next";

export default function GiftThankYou() {
  const navigate = useNavigate();
  const { t } = useTranslation("publicMisc");

  return (
    <div className="gift-thank-you-page">
      <section className="gift-thank-you-card">
        <div
          className="gift-thank-you-hero"
          role="img"
          aria-label={t("giftThankYou.heroAlt")}
        />
        <div className="gift-thank-you-fade" />

        <div className="gift-thank-you-content">
          <div className="gift-thank-you-eyebrow">{t("giftThankYou.eyebrow")}</div>

          <h1 className="gift-thank-you-title">
            <Trans
              i18nKey="giftThankYou.title"
              ns="publicMisc"
              components={{ em: <em /> }}
            />
          </h1>

          <p className="gift-thank-you-body">
            {t("giftThankYou.body")}
          </p>

          <p className="gift-thank-you-note">
            {t("giftThankYou.note")}
          </p>

          <button
            type="button"
            className="gift-thank-you-cta"
            onClick={() => navigate("/")}
          >
            {t("giftThankYou.returnCta")}
          </button>

          <div className="gift-thank-you-signoff">
            <div className="gift-thank-you-team">
              {t("giftThankYou.team")}
            </div>
            <div className="gift-thank-you-tagline">
              {t("giftThankYou.tagline")}
            </div>
            <div className="gift-thank-you-pillars">
              <span>{t("giftThankYou.pillars.evidence")}</span>
              <span className="dot">&bull;</span>
              <span>{t("giftThankYou.pillars.inspiration")}</span>
              <span className="dot">&bull;</span>
              <span>{t("giftThankYou.pillars.empowerment")}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
